export default __webpack_public_path__ + "static/media/vuetifyjs.3848fcff.svg";